import { defineStore } from "pinia";
import { reactive } from "vue";

export const useMessageStore = defineStore("message", () => {
  const messages = reactive([]);
  let nextId = 0;

  function push(message) {
    messages.push({ id: nextId++, ...message });
  }

  function remove(id) {
    const index = messages.findIndex((m) => m.id === id);
    if (index !== -1) messages.splice(index, 1);
  }

  function addSuccess(message) {
    push({ type: "success", message, timeout: 4000 });
  }

  function addError(message) {
    push({ type: "error", message });
  }

  function addWarning(message) {
    push({ type: "warning", message });
  }

  function addInfo(message) {
    push({ type: "info", message, timeout: 6000 });
  }

  function addMessage(type, message, timeout) {
    push({ type, message, timeout });
  }

  function addI18nMessage(type, key, params, timeout) {
    push({ type, key, params, timeout });
  }

  return { messages, remove, addSuccess, addError, addWarning, addInfo, addMessage, addI18nMessage };
});
